import { render } from "./AboutModal.vue?vue&type=template&id=4622a122"
import script from "./AboutModal.vue?vue&type=script&lang=js"
export * from "./AboutModal.vue?vue&type=script&lang=js"

import "./AboutModal.vue?vue&type=style&index=0&id=4622a122&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__